import JSONAPIClient from '../JSONAPIClient'

JSONAPIClient.define('bulk_update', {
  loan_file_ids: '',
  changes_to_apply: '',
  status: '',
  results: '',
}, { collectionPath: 'loan_files/bulk_updates' })
